import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import axios from 'axios';

import HttpPlugin from './plugins/Http.js';
import ToastPlugin from './plugins/v-toast.js';

import loginStore from './store/loginStore.js';
import routes from './routes/LoginRoutes.js';

require('./style/login-common.css');
require('./style/common-component.css');
require('./style/common-toast.css');
require('./style/common-grid.css');
require('./style/common-our-logo.css');
require('./style/common-buttons.css');
require('./style/common-table.css');
require('./style/common-input.css');
require('./style/list-details.css');
require('./style/loading.css');
require('./style/admin-login.css');

Vue.config.productionTip = false;

Vue.use(Vuex);
const store = new Vuex.Store(loginStore);

Vue.use(ToastPlugin);
Vue.use(HttpPlugin, {
  baseURL: window.appConfig.apiUrl + '/',
  withCredentials: true,
  headers: {'x-cors-domain': window.location.protocol + '//' + window.location.hostname},
});
Vue.use(VueRouter);

(function() {
  window.api = axios.create({
    baseURL: window.appConfig.apiUrl + '/',
    withCredentials: true,
    headers: {'x-cors-domain': window.location.protocol + '//' + window.location.hostname}
  });
  
  window.api.interceptors.response.use(function (response) {
    if (response.headers['x-xsrf-token']) {
      document.cookie = 'XSRF-TOKEN=' + response.headers['x-xsrf-token'] + '; path=/';
    }
    return response;
  });
}());

const router = new VueRouter({
  routes
}); 

new Vue({
  router,
  store
}).$mount('#app')
